<template>
  <div  style="position: relative">
    <!-- <div
      style="z-index: 10"
      class="loading-overlay"
    ></div> -->
    <div class="w-100">
      <div
        style="z-index: 10"
        class="loading-overlay w-100"
        v-if="ngoInfo && ngoInfo.current_stage == 4"
      ></div>
      
      <div class="d-flex justify-content-between align-items-center">
      
        <h3>معلومات المنظمة</h3>
        <div v-if="(ngoInfo && ngoInfo.current_stage != 4)">
          <b-button
            class="mx-50"
            v-if="!isEdit && (isAdd === false)"
            @click="onClickEdit"
            variant="info"
            >تعديل</b-button
          >
          <b-button
            class="mx-50"
            v-if="isCancel"
            @click="isAdd = false; isCancel = false; isEdit = false"
            variant="info"
            >إلغاء</b-button
          >

          <template v-if="isEdit">
            <b-button v-if="Object.keys(ngoForm).length !== 0" @click="onCancel" variant="danger" class="mx-50"
              >الغاء</b-button
            >
            <loader-btn
              noIcon
              @click="onSave"
              variant="success"
              :loading="working"
              >حفظ</loader-btn
            >
          </template>
        </div>
      </div>
      <hr />
      <ngo-info v-if="isAdd" @confirm="onConfirmAdd"  ref="ngoForm" :intializeForm="form" :loading="working" :isCancel="isCancel"></ngo-info>
      <b-container v-else class="labels-cont" cols="12">
      <validation-observer ref="ngoInfo">
        <b-row cols="12">
          <b-row>
            <b-col lg="4" md="6">
              <form-input
                label="اسم المنظمة قيد التأسيس"
                id="ngo-name"
                v-model="ngoForm.ngo_name"
                plaintext
              />
            </b-col>
            <b-col lg="4" md="6">
              <form-input
                label="الاسم البديل الأول"
                id="ngo-name"
                v-model="ngoForm.fst_alt_ngo_name"
                plaintext
              />
            </b-col>
            <b-col lg="4" md="6">
              <form-input
                label="الاسم البديل الثاني"
                id="ngo-name"
                v-model="ngoForm.sec_alt_ngo_name"
                plaintext
              />
            </b-col>
            
            <b-col lg="4" md="6">
              <form-input
                v-if="!isEdit"
                label="الشكل القانوني"
                id="legal-form"
                :value="$t(ngoForm.legal_form_type)"
                plaintext
              />
            </b-col>
            <b-col lg="4" md="6">
              <b-form-group
                v-if="!isEdit"
                label="التصنيفات"
                label-for="classification"
              >
                <b-form-input
                  id="classification"
                  :value="classifications"
                  plaintext
                />
              </b-form-group>
            </b-col>
            <b-col lg="4" md="6">
              <b-form-group v-if="!isEdit" label="يتناول نشاطها المحافظات" label-for="gov">
                <b-form-input id="gov" v-model="governorates" plaintext />
              </b-form-group>
            </b-col>
          
          <b-col lg="12" md="6">
            <div class="form-input mb-1 info-cont" v-if="!isEdit">
              <label class="mb-1" for="obj">الأهداف</label>
              <div style="white-space: pre-line" id="obj">
                {{ ngoForm.objectives }}
              </div>
            </div>

            <form-textarea v-model="ngoForm.objectives" rules="required" v-else label="الأهداف">
            </form-textarea>
          </b-col>
            <b-col lg="12">
              <h3> معلومات المقر </h3>
              <hr />
              
            </b-col>
            
            <b-col lg="4" md="6">
              <form-input
                label="اسم المقر"
                id="address"
                v-model="ngoForm.hq.name"
                :plaintext="!isEdit"
                :rules="!isEdit ? '' : 'required'"
              />
            </b-col>
            <b-col lg="4" md="6">
              <b-form-group v-if="!isEdit" label="محافظة المقر" label-for="gov">
                <b-form-input
                  id="gov"
                  :value="
                    ngoForm.hq.governorate ? ngoForm.hq.governorate.name_ar : ''
                  "
                  plaintext
                />
              </b-form-group>
            </b-col>
            <b-col lg="4" md="6">
              <b-form-group v-if="!isEdit" label="المنطقة/الحي" label-for="gov">
                <b-form-input
                  id="gov"
                  :value="
                    ngoForm.hq.subDistrict ? ngoForm.hq.subDistrict.name_ar : ''
                  "
                  plaintext
                />
              </b-form-group>
            </b-col>
            <b-col lg="4" md="6">
              <form-input
                label="عنوان المقر"
                id="address"
                v-model="ngoForm.hq.address"
                :plaintext="!isEdit"
                :rules="!isEdit ? '' : 'required'"
              />
            </b-col>
            <b-col lg="12">
              <h3> معلومات العقار </h3>
              <hr />
              
            </b-col>
            
            <b-col lg="4" md="6">
              <form-input
                label="رقم العقار"
                id="address"
                v-model="ngoForm.realEstate.number"
                :plaintext="!isEdit"
                :rules="!isEdit ? '' : 'required'"
              />
            </b-col>
            <b-col lg="4" md="6">
              <b-form-group v-if="!isEdit" label="نوع العقار" label-for="gov">
                <b-form-input
                  id="gov"
                  :value="
                    ngoForm.realEstate.estateType ? ngoForm.realEstate.estateType.name_ar : ''
                  "
                  plaintext
                />
              </b-form-group>
            </b-col>
            
            <b-col lg="4" md="6">
              <form-input
                label="المنطقة الإدارية"
                id="address"
                v-model="ngoForm.realEstate.region"
                plaintext
              />
            </b-col>
            
            
            <b-col lg="4" md="6">
              <form-input
                label="الحصة السهمية"
                id="address"
                v-model="ngoForm.realEstate.equity_share"
                plaintext
              />
            </b-col>
            <b-col lg="4" md="6">
              <b-form-group v-if="!isEdit" label="صيغة التملك" label-for="gov">
                <b-form-input
                  id="gov"
                  :value="
                    ngoForm.realEstate.estateType ? ngoForm.realEstate.estateType.name_ar : ''
                  "
                  plaintext
                />
              </b-form-group>
            </b-col>
            <b-col lg="4" md="6">
              <form-input
                label="موضوع بالخدمة"
                id="address"
                v-model="ngoForm.realEstate.is_operating === 1 ? 'نعم' : 'لا'"
                plaintext
              />
            </b-col>
                
            <b-col cols="4">
                <div class="info-card px-2 py-1 my-1">
                <div class="d-flex align-items-center justify-content-between">
                    <div>
                      وثيقة العقار
                    </div>
                    <div>
                    <b-button
                    
                        variant="flat-info"
                        v-b-toggle.doc-view
                        class="btn-icon mx-25"
                        v-b-tooltip.hover.v-info.bottom
                        title="عرض المستند المرفوع"
                        :to="{ name: 'file-view', query: { ep:ngoForm.realEstate.estate_document } }"
                    >
                        <feather-icon icon="EyeIcon"
                    /></b-button>
                    </div>
                </div>
                <div>
                    <hr />
                </div>
                </div>
            </b-col> 
          </b-row>
        </b-row>
      </validation-observer>
      </b-container>
    </div>
  </div>
</template>

<script>
import {
  BRow,
  BButton,
  BCol,
  BContainer,
  BFormGroup,
  BFormRadioGroup,
  BFormInput,
  VBTooltip ,
  VBToggle
} from "bootstrap-vue";
import LoaderBtn from "@/components/loader-btn.vue";
import { mapGetters, mapActions } from "vuex";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import FormSelect from "@/components/form-select/index.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import FormInput from "@/components/form-input/index.vue";
import FormTextarea from "@/components/form-textarea/index.vue";
import ClassSelect from "@/components/class-select/index.vue";
import NgoInfo from "../../components/NgoInfo.vue";
import InfoCard from "@/components/InfoCard.vue"
export default {
  components: {
    BRow,
    BButton,
    BCol,
    BContainer,
    BFormGroup,
    BFormRadioGroup,
    BFormInput,
    LoaderBtn,
    ToastificationContent,
    FormSelect,
    ValidationObserver,
    FormInput,
    ValidationProvider,
    FormTextarea,
    ClassSelect,
    NgoInfo,
    InfoCard
  },
  directives: {
    "b-tooltip": VBTooltip,
    "b-toggle": VBToggle,
  },
  data() {
    return {
      isEdit : false,
      ifEdit : false,
      isAdd : false,
      isCancel : false,
      commentsModal: false,
      ngoForm: {},
      form:{ "est_account_id" : 149 , 'email':"esraa@test.com" , },
      propertyFormOptions: [
        {
          text: "عقد إيجار",
          value: "lease",
        },
        {
          text: "حق انتفاع",
          value: "usufruct",
        },
        {
          text: "عقد عارية",
          value: "loan",
        },
        {
          text: "تخصيص إداري",
          value: "administrative_allocation",
        },
      ],
      legalFormOptions: [
        {
          text: "جمعية",
          value: "association",
        },
        {
          text: "مؤسسة",
          value: "institution",
        },
        {
          text: "اتحاد",
          value: "alliance",
        },
      ],
    };
  },
  computed: {
    ...mapGetters("TempNgo", ["ngoInfo", "working" , "accountInfo"]),
    classifications() {
      const newClass = [...this.ngoInfo.classifications];
      return newClass.map((el) => el.name_ar).join(" , ");
    },
    governorates() {
      const newGov = [...this.ngoInfo.governorates];
      return newGov.map((el) => el.name_ar).join(" , ");
    },
  },
  methods: {
    classificationPos(dropdownList, component, { width, top, left }) {
      dropdownList.style.top = top;
      dropdownList.style.right = `${parseInt(left) + parseInt(width) + 15}px`;
      dropdownList.style.width = width;
    },
    ...mapActions("TempNgo", ["updateNgoInfo" , "addNgoInfo", "changeCurrentStage" , "fetchNgoData"]),
    async onConfirmAdd(form){
      
    if(form.governorate_id === form.old_hq_governorate_id ){
      delete form.old_hq_governorate_id
      delete form.governorate_id
    }
    form.est_account_id = this.accountInfo.id ;
    const keys = Object.keys(form);
      var req = new FormData();
      for (const index in keys) {
        const key = keys[index];
        if(`${key}` ==='name' || `${key}` ==='address' || `${key}` ==='longitude' || `${key}` ==='latitude' || `${key}` ==='governorate_id' || `${key}` ==='sub_district_id') {
          req.append(`ngo_hq[${key}]`, form[key]);

        }
        else if(`${key}` ==='number' || `${key}` ==='region' || `${key}` ==='is_operating' || `${key}` ==='possessive_form_id' || `${key}` ==='estate_type_id' || `${key}` ==='equity_share') {
          req.append(`real_estate[${key}]`, form[key]);

        }
        else if(`${key}` ==='estate_document'){
          if(typeof form[key] === "object"){
            req.append(`real_estate[${key}]`, form[key]);
          }
        }
        else if(`${key}` ==='classification_ids'){
          for (let i = 0; i < form.classification_ids.length; i++) {
            req.append(`classification_ids[${i}]`, form.classification_ids[i]);
            console.log(form.classification_ids[i]);
          }
        }
        else if(`${key}` ==='governorate_ids'){
          for (let i = 0; i < form.governorate_ids.length; i++) {
            req.append(`governorate_ids[${i}]`, form.governorate_ids[i]);
            console.log(form.governorate_ids[i]);
          }

        }
        else{
          req.append(`${key}`, form[key]);
        }
      }
              if(form.hasOwnProperty('id')){
                console.log("edit")
                
                req.append("_method", "PUT");
                await this.updateNgoInfo(req)
              .then(() => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "تمت العملية بنجاح",
                    icon: "CheckIcon",
                    variant: "success",
                  },
                });
                this.ngoForm = JSON.parse(JSON.stringify(this.ngoInfo));
                this.isEdit = false ;
                this.isAdd = false ;
              })
              .catch(() => {
                this.form = JSON.parse(JSON.stringify(this.ngoInfo));
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "خطأ",
                    icon: "AlertCircleIcon",
                    text: "حصل خطأ أثناء العملية",
                    variant: "danger",
                  },
                });
              });

              }else{

                await this.addNgoInfo(req)
                  .then(() => {
                    this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: "تمت العملية بنجاح",
                        icon: "CheckIcon",
                        variant: "success",
                      },
                    });
                    
                    this.changeCurrentStage(1)
                    this.ngoForm = JSON.parse(JSON.stringify(this.ngoInfo));
                    this.isAdd = false;
                    this.fetchNgoData()
                  })
                  .catch(() => {
                  });
              }
            // }

      //   this.isEdit = false;
    },
    onClickEdit(){
      this.isAdd = true;
      this.isCancel = true
    },
    async onSave() {
      console.log("onSave")

      this.$refs.ngoInfo.validate().then(async (success) => {
        if (success) {
              const toSave = {};
              for (const key in this.ngoForm) {
                

                if (Object.hasOwnProperty.call(this.ngoForm, key)) {
                 
                 if (this.ngoForm[key] != this.ngoInfo[key]) {
                  if(key === 'governorates' ){
                    if(typeof this.ngoForm[key][0] === 'object'){

                      const ids = [];
                      this.ngoForm[key].forEach(obj => {
                        ids.push(obj.id)
                      })
                      toSave['governorate_ids'] = ids;
                    }
                    else{
                      toSave['governorate_ids'] = this.ngoForm[key];
                    }
                  }
                  else if(key === 'classifications'){
                    
                    
                    if(typeof this.ngoForm[key][0] === 'object'){

                      const ids = [];
                      this.ngoForm[key].forEach(obj => {
                        ids.push(obj.id)
                      })
                      toSave['classification_ids'] = ids;
                    }
                    else{
                    toSave['classification_ids'] = this.ngoForm[key];
                    }
                  }
                  else{

                    toSave[key] = this.ngoForm[key];
                  }
                  }
                }
              }
              await this.updateNgoInfo(toSave)
              .then(() => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "تمت العملية بنجاح",
                    icon: "CheckIcon",
                    variant: "success",
                  },
                });
                this.ngoForm = JSON.parse(JSON.stringify(this.ngoInfo));
                this.isEdit = false ;
                this.isAdd = false ;
              })
              .catch(() => {
                this.form = JSON.parse(JSON.stringify(this.ngoInfo));
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "خطأ",
                    icon: "AlertCircleIcon",
                    text: "حصل خطأ أثناء العملية",
                    variant: "danger",
                  },
                });
              });

          this.isEdit = false;
        }
      });
    },
    onCancel() {
      this.ngoForm = JSON.parse(JSON.stringify(this.ngoInfo));
      console.log("this.ngoForm" , this.ngoForm)
      this.isEdit = false;
      this.isAdd = false;

    },
  },
  mounted() {
    // this.changeCurrentStage(6)
    // document.getElementsByClassName("app-content")[0].classList.add("temp-ngo");
    this.ngoForm = JSON.parse(JSON.stringify(this.ngoInfo)) || {};
    console.log("this.ngoForm" , this.ngoForm )
    console.log("this.ngoInfo" , this.ngoInfo ) 
    console.log("dfdf" , Object.keys(this.ngoForm).length)
    //  && Object.keys(this.ngoForm) > 0
    if(Object.keys(this.ngoForm).length === 0){
      console.log("add")
      this.isAdd = true;
      this.isEdit = false;
    }else{
      // this.form = {"est_account_id" : this.accountInfo.id , 'email':this.accountInfo.email , 'occupation_legal_form' :'lease'};
      
      
      console.log("edit")
      this.isEdit = false;
      this.isAdd = false;
      // this.$refs.ngoForm.init(this.form);
    }
  },
};
</script>

<style>
.temp-ngo {
  padding-top: 5rem !important;
}
.vs__dropdown-menu {
  z-index: 10 !important;
}
</style>
